module.exports = __webpack_public_path__ + "media/file_icons/youtube-9ed81853.svg";